<template>
    <div class="home">
        <div class="home__promo">
            <div class="home__col">
                <h3 class="text-gray-200 font-medium max-md:text-xl">
                    {{ bannerTopLine }}
                </h3>
                <h1 class="text-gray-200 max-md:text-3xl">
                    {{ bannerBottomLine }}
                </h1>
                <div class="home__buttons" v-if="!user && !isLoading">
                    <btn-wrapper
                        :params="{
                        class: 'home__button mr-4 !bg-default',
                        type: 'link',
                        title: t('auth.login.submit'),
                        path: '/auth',
                    }"
                    />
                    <btn-wrapper
                        v-if="isSignUpEnabled"
                        :params="{
                            class: 'home__button',
                            type: 'link',
                            title: t('auth.signup.submit'),
                            path: '/auth/signup',
                        }"
                    />
                </div>
                <div class="home__buttons" v-else />
                <slot/>
            </div>
            <div class="home__background bg-gray-50 relative overflow-hidden">
                <div
                    class="absolute inset-0 bg-gradient-to-r from-transparent via-default/30 to-transparent opacity-30 -translate-x-full animate-shimmer z-0">
                </div>
                <img v-if="mobileBannerImageUrl" class="home__background_mobile absolute w-full h-full object-cover z-1"
                     :src="mobileBannerImageUrl" alt="">
                <img v-if="desktopBannerImageUrl" class="home__background_desktop absolute w-full h-full object-cover z-1"
                     :src="desktopBannerImageUrl" alt="">
            </div>
        </div>

        <div class="container">
            <div class="home__row">
                <h2>{{ t('home.portal') }}</h2>
            </div>
            <div class="home__wrapper">
                <RouterView/>
            </div>

            <!-- <LocalSearch placeholder="Поиск по курсам и категориям" @update="setSearchText"/> -->
            <template v-if="$route.name !== 'CourseList'">
                <div class="home__categories" v-if="categories.length">
                    <Category
                        class="home__item"
                        v-for="(item, index) in categories"
                        :key="`category-${index}`"
                        :params="{item: item}"
                    />
                </div>
                <Pagination
                    class="home__pagination"
                    v-if="categories"
                    @update="setCatPage"
                    :count="catsPages * 10"
                    scrollTo=".home__row h2"
                />
                <h2 class="home__title home__title_size_m  home__title_indent_m" v-if="coursesPerPage.length"> {{ t('course.category')}} {{ mainCategory.name }}</h2>
                <div class="home__courses" v-if="coursesPerPage.length">
                    <Course
                        class="home__item"
                        v-for="(item, index) in coursesPerPage"
                        :key="`course-${index}`"
                        :params="{item: item}"
                    />
                </div>
                <Pagination
                    class="home__pagination"
                    v-if="filteredCourses.length"
                    @update="setPage"
                    :page-size="5"
                    :count="filteredCourses.length"
                />
            </template>
        </div>
    </div>
</template>

<script setup>
import {useStore} from 'vuex'
import {computed, onMounted, ref} from 'vue'
import Category from '@/components/UI/category/index.vue'
import Course from '@/components/UI/course/Course.vue'
import Pagination from '@/components/UI/pagination/index.vue'
import {getArrayByPage} from '@/script'
import db from '@/database'
import {useI18n} from 'vue-i18n'

const store = useStore()
const currentPage = ref(1)
const catPage = ref(1)
const searchText = ref('')
const catsPages = ref(null)
const categories = ref([])
const isSignUpEnabled = ref(true)
const isLoading = ref(true)

const {t} = useI18n()

const user = computed(() => store.getters.user)

const coursesPerPage = computed(() => {
    return getArrayByPage(filteredCourses.value, 5, currentPage.value)
})

const filteredCourses = computed(() => {
    return mainCategory.value?.courses?.filter(el => el.fullname.toLowerCase().includes(searchText.value.toLowerCase())) || []
})

const mainCategory = computed(() => {
    const mainCat = categoriesList.value.find(el => el.id === 1)
    //eslint-disable-next-line
    return !!mainCat ? mainCat : categoriesList.value[0] || []
})

const categoriesList = computed(() => store.getters.categories)
const mobileBannerImageUrl = computed(() => store.getters.getCustomInformation?.banner?.img?.mobile)
const desktopBannerImageUrl = computed(() => store.getters.getCustomInformation?.banner?.img?.desktop)
const bannerTopLine = computed(() => store.getters.getCustomInformation?.banner?.topLine)
const bannerBottomLine = computed(() => store.getters.getCustomInformation?.banner?.bottomLine)

const getCategories = () => {
    const page = catPage.value - 1
    db.getCategories(page).then(res => {
        if (res) {
            categories.value = res.data
            catsPages.value = res.pagesize
            return
        }
        store.dispatch('getCategoriesByPage', {
            criteria: [{
                    key: 'parent',
                    value: 0
                }],
            addsubcat: 0,
            page
        }).then(res => {
            if (res.exception)
                return
            categories.value = res.data
            catsPages.value = res.pagesize
            if (res.data.length > 0) {
                db.saveCategories({
                    categories: res, page
                })
            }
        })
    })
}

onMounted(() => {
    getCategories()
    triggerSiteViewEvent()
})

const setPage = page => currentPage.value = page

const setCatPage = (page) => {
    catPage.value = page
    getCategories()
}

if (!user.value) {
    store.dispatch('getSignUpSettings').then(res => {
        if (res.errorcode) {
            isSignUpEnabled.value = false
        }
        isLoading.value = false
    }).catch(() => {
        isLoading.value = false
    })
}

const triggerSiteViewEvent = () => {
    store.dispatch('triggerCourseViewEvent', 1).then(res => {
        if (res?.errorcode) {
            errorMessage.value = res.message
        }
    })
}
</script>

<style lang="scss" scoped>
@import './scss/home.scss';
</style>
